<template>
  <svg class="sparkline" :width="width" :height="height">
    <path class="axis--line" :d="axis" fill="none"></path>
    <path
      class="sparkline--line"
      :d="shape"
      fill="none"
      :stroke-width="stroke"
    ></path>
    <path
      class="sparkline--fill"
      :d="[shape, fillEndPath].join(' ')"
      stroke="none"
    ></path>
  </svg>
</template>

<script>
export default {
  props: ["data", "width", "height"],
  data() {
    return {
      stroke: 3,
    };
  },

  computed: {
    highestPoint() {
      return Math.max.apply(null, this.data) + 1;
    },
    lowestPoint() {
      return Math.min.apply(null, this.data);
    },
    axis() {
      const coordinates = [];
      const stroke = 1;
      const height = this.height - stroke * 2;
      const y =
        height -
        ((0 - this.lowestPoint) / (this.highestPoint - this.lowestPoint)) *
          height;
      coordinates.push({
        x: 0,
        y: y,
      });
      coordinates.push({ x: 400, y: y });

      const path = [];

      coordinates.forEach((point) =>
        path.push(["L", point.x, point.y].join(" "))
      );

      return ["M" + coordinates[0].x, coordinates[0].y, ...path].join(" ");
    },
    shape() {
      const width = this.width;
      const height = this.height;

      const data = this.data || [];
      const coordinates = [];
      const totalPoints = this.data.length - 1;

      data.forEach((item, n) => {
        const x = (n / totalPoints) * width;
        const y =
          height -
          ((item - this.lowestPoint) / (this.highestPoint - this.lowestPoint)) *
            height;

        coordinates.push({ x, y });
      });

      if (!coordinates[0]) {
        return (
          "M 0 " +
          this.stroke +
          " L 0 " +
          this.stroke +
          " L " +
          this.width +
          " " +
          this.stroke
        );
      }

      const path = [];

      coordinates.forEach((point) =>
        path.push(["L", point.x, point.y].join(" "))
      );

      return ["M" + coordinates[0].x, coordinates[0].y, ...path].join(" ");
    },
    fillEndPath() {
      return `V ${this.height} L 4 ${this.height} Z`;
    },
  },
};
</script>

<style>
svg {
  stroke: #1f8ceb;
  fill: rgba(31, 140, 235, 0.06);
  transition: all 1s ease-in-out;
}
.axis--line {
  stroke: black;
}

svg path {
  box-sizing: border-box;
}
</style>
